import {login, logout, getInfo, chooseAccount} from 'api';
import Cookies from 'js-cookie';


const user = {
  state: {
    name: '',
    uid: '',
    avatar:'',
    promotorType: '',
    accountState:'',
    hasRole: 0,
    isPromotorDisplay: false
  },

  mutations: {
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_PROMOTORTYPE: (state, promotorType) => {
      state.promotorType = promotorType;
    },
    SET_ISPROMOTORDISPLAY: (state, isPromotorDisplay) => {
      state.isPromotorDisplay = isPromotorDisplay;
    },
    SET_ACCOUNTSTATE: (state, accountState) => {
      state.accountState = accountState;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_UID: (state, uid) => {
      state.uid = uid;
    },
    SET_HASROLE: (state, hasRole) => {
      state.hasRole = hasRole;
    },
    LOGIN_SUCCESS: () => {
      //console.log('login success')
    }
  },

  actions: {

    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      var password = userInfo.password
      return new Promise((resolve, reject) => {
        login(username, password).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },

    Choose({ commit }, id){
      return new Promise((resolve, reject) => {
        chooseAccount(id).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
       /* const data = {
          promotorType:1,
          nickName:'adf',
          id:22,
          avatar:'asd',
          hasRole:0
        }
        resolve({data});*/
        getInfo().then(response => {
          let data = response.data;
          commit('SET_ACCOUNTSTATE', data.accountState);
          commit('SET_ISPROMOTORDISPLAY', data.isPromotorDisplay);
          commit('SET_PROMOTORTYPE', data.promotorType);
          commit('SET_NAME', data.nickName);
          commit('SET_UID', data.id);
          commit('SET_AVATAR', data.avatar);
          commit('SET_HASROLE', data.hasRole);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },


    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then((res) => {
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js